import { ValueDecoder } from '@youhelp-ru/common/routing/lib';
import { IRouter } from '../router';
import { decodeQueryString } from './utils';
import { QueryParamsDictionary } from './model';

export const getQueryParams = <T extends QueryParamsDictionary = QueryParamsDictionary>(
  router: IRouter,
  defaultParams?: T,
  opts?: { decoder?: ValueDecoder },
) => decodeQueryString(router.location.search, defaultParams, opts) as T;
